<template>
<div>
    <gform :props="props" :rowdata="rowdata" :formmodel="'inlineform'" :thetext="'OPT'"></gform>
</div>
</template>

<script>
import gform from "./gform"
export default {
    components:{gform},
    props: ["props", "rowdata"],
    data(){
        return {
 
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/form/inlineform.vue